// extracted by mini-css-extract-plugin
export default {"title":"Payment_title__6PqSG","payment":"Payment_payment__37qGU","spinner":"Payment_spinner__NkzXT"};